import React, { useState } from 'react'
import ProgramCard from './Card';

function DicoverProgramCard({ listPrograms }: any) {
    return (

        <div className="row g-3">
            {listPrograms.map((program, i: number) => {
                return (
                    <ProgramCard program={program} key={i} />
                )
            })}
        </div >
    )
}

export default DicoverProgramCard
